module.exports = __webpack_public_path__ + "static/12-1f134572ffc49b894b56209897592b0e.jpg";